import { render, staticRenderFns } from "./aboutGoods.vue?vue&type=template&id=75751572&scoped=true&"
import script from "./aboutGoods.vue?vue&type=script&lang=js&"
export * from "./aboutGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75751572",
  null
  
)

export default component.exports